var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.707 17.792a1 1 0 1 0 1.414 1.414l5.657-5.656 5.657 5.656a1 1 0 0 0 1.414-1.414l-5.657-5.657L18.85 6.48a1 1 0 0 0-1.414-1.415l-5.657 5.657-5.657-5.657A1 1 0 1 0 4.707 6.48l5.657 5.656-5.657 5.657Z",
    clipRule: "evenodd"
  })));
};
export default SvgClose;